import React from 'react'
import clsx from 'clsx'

import headerStyles from 'app/RuangGTKHomepageV3/styles.module.css'

interface PageContainerProps {
  children: React.ReactNode
  className?: string
}

/**
 * Uses the exact same responsive container class as Ruang GTK header + breadcrumb.
 */
const PageContainer = ({ children, className }: PageContainerProps) => (
  <div
    className={clsx(headerStyles['base-rgtk-homepage'], 'w-full', className)}
  >
    {children}
  </div>
)

export default PageContainer
